import React, { useEffect, useState } from "react";
import { ModalMiaProps } from "./ModalMia.types";
import Modal from "../Modal/Modal";
import FormSimulation from "../FormSimulation/FormSimulation";
import { createPortal } from "react-dom";
import { ModalMiaContainer, GlobalModalMiaStyle } from "./ModalMia.style";

declare const window: any; 
export function ModalMia({
    onClose,
    idModal,
    modalTitle,
    modalTitleColor,
    modalDescription,
    modalDescriptionColor,
    modalButton,
    nameLabel,
    namePlaceHolder,
    nameError,
    nameRequired,
    nameRequiredText,
    emailLabel,
    emailPlaceHolder,
    emailError,
    emailRequired,
    emailRequiredText,
    celularLabel,
    celularPlaceHolder,
    celularError,
    celularRequired,
    celularRequiredText,
    estadoLabel,
    estadoPlaceHolder,
    estadoRequired,
    estadoRequiredText,
    cidadeLabel,
    cidadePlaceHolder,
    cidadeRequired,
    cidadeRequiredText,
    checkBoxText,
    checkBoxRequired,
    checkBoxRequiredText,
    siteKey,
    link,
    cqPath,
    backgroundColor
    
}: ModalMiaProps){
    const [requestError, setRequestError] = useState(false);

    function handleClose() {
        setRequestError(false);
        onClose();        
    }

    const modalHeader = <h2 key="modal-title-h2" className="modal__title">{modalTitle}</h2>;

    return createPortal (
        <ModalMiaContainer>
            <GlobalModalMiaStyle $backgroundColor={backgroundColor} $modalTitleColor={modalTitleColor} />
            <Modal
            onClose={handleClose}
            idText="modalMia"
            hideArrow={true}
            header={modalHeader}
            >
            <FormSimulation
                    id={idModal ?? "Formulario-ModalMia"}
                    modalButton={modalButton}
                    formLink={link} 
                    siteKey={siteKey}
                    onClose={onClose}
                    requestError={setRequestError}
                    nameLabel={nameLabel}
                    namePlaceHolder={namePlaceHolder}
                    nameError={nameError}
                    nameRequired={nameRequired}
                    nameRequiredText={nameRequiredText}
                    emailLabel={emailLabel}
                    emailPlaceHolder={emailPlaceHolder}
                    emailError={emailError}
                    emailRequired={emailRequired}
                    emailRequiredText={emailRequiredText}
                    celularLabel={celularLabel}
                    celularPlaceHolder={celularPlaceHolder}
                    celularError={celularError}
                    celularRequired={celularRequired}
                    celularRequiredText={celularRequiredText}
                    estadoLabel={estadoLabel}
                    estadoPlaceHolder={estadoPlaceHolder}
                    estadoRequired={estadoRequired}
                    estadoRequiredText={estadoRequiredText}
                    cidadeLabel={cidadeLabel}
                    cidadePlaceHolder={cidadePlaceHolder}
                    cidadeRequired={cidadeRequired}
                    cidadeRequiredText={cidadeRequiredText}
                    checkBoxText={checkBoxText}
                    checkBoxRequired={checkBoxRequired}
                    checkBoxRequiredText={checkBoxRequiredText} 
                    personalButton={modalButton} 
                    title={modalTitle} 
                    titleColor={modalTitleColor} 
                    subTitle={modalDescription} 
                    subTitleColor={modalDescriptionColor} 
                    backgroundColor={backgroundColor} 
                    isInEditor={false} 
                    isInModal={true}
                    cqPath={cqPath}>                       
            </FormSimulation>
            </Modal>
        </ModalMiaContainer>,
        document.body
    )
}
